/**
 * Le retour du menu d'une séance de « Tous mes lives », dit à l'élève : au tutoiement. Seul un échec
 * prend le repli d'une annulation : un succès (« Votre message a bien été transmis. ») devenait
 * « Impossible d'annuler ». Pur, testé seul (`studentMenuFeedback.test.ts`).
 */
import { studentRefusalText } from "../../../hooks/studentRefusal"

export const CANCEL_FAILED = "Impossible d'annuler. Réessaie dans un instant."

export function studentMenuFeedback<F extends { message: string; error?: boolean }>(feedback: F): F {
    return {
        ...feedback,
        message: studentRefusalText(feedback.message, feedback.error === true ? CANCEL_FAILED : feedback.message),
    }
}
